import { render, staticRenderFns } from "./PlushieViewPage.vue?vue&type=template&id=b056f258&scoped=true&"
import script from "./PlushieViewPage.vue?vue&type=script&lang=ts&"
export * from "./PlushieViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./PlushieViewPage.vue?vue&type=style&index=0&id=b056f258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b056f258",
  null
  
)

export default component.exports